import { render, staticRenderFns } from "@/modules/Newcase/templates/case-create.html?vue&type=template&id=6f7b7dba&scoped=true&"
import script from "@/modules/Newcase/scripts/case-create.ts?vue&type=script&lang=js&"
export * from "@/modules/Newcase/scripts/case-create.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Newcase/styles/case-create.scss?vue&type=style&index=0&id=6f7b7dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7b7dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
